import React from 'react';
import { InfoCircleOutlined } from '@ant-design/icons';
import { Avatar, Col, Tooltip, Typography } from 'antd';

import classnames from 'classnames';
import { AvatarPropertiesItem } from 'common/components/mapping-properties/MappingSourceProperties';
import { getHighlightedText } from 'common/components/reporting/entity-and-attributes/utils';

const { Text } = Typography;

const PropertiesItems = React.memo(
  ({ displayName, dataType, searchText, fieldName, children }) => {
    const highlightSearchText = getHighlightedText(displayName, searchText);

    return (
      <>
        <Col style={{ paddingLeft: 0, width: 40 }}>
          <Avatar
            shape='square'
            className='property-item__icon'
            icon={<AvatarPropertiesItem propertyType={dataType} />}
          />
        </Col>
        <Col
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: 'calc(100% - 40px)',
          }}
        >
          <Text
            className={classnames({
              'property-item__name': true,
            })}
            strong={true}
            ellipsis={{ tooltip: displayName }}
          >
            {highlightSearchText}&nbsp;
            {fieldName === 'fieldsChanged.lastChanged' ? (
              <Tooltip title='You must select the Field Path before choosing the Last Changed option, which is only intended to support the search for the Field path.'>
                <InfoCircleOutlined style={{ fontSize: 16 }} />
              </Tooltip>
            ) : null}
          </Text>
          {children}
        </Col>
      </>
    );
  }
);

export default PropertiesItems;
